/**
 * Anklickbare Aufgabenlisten. Die Vorschau rendert `- [ ]` als Checkbox mit
 * `data-task`-Index (siehe task_lists-Regel in ./index.ts); hier wird der
 * Klick zurück in den Markdown-Quelltext geschrieben. Dadurch bleibt der Text
 * die einzige Wahrheit – es gibt keinen zweiten Zustand daneben.
 */

/** Zeilenanfang, optional mit Aufzählungszeichen, dann `[ ]` bzw. `[x]`. */
const TASK_RE = /^([ \t]*(?:(?:[-*+]|\d+[.)])[ \t]+)?)\[([ xX])\]/gm;

export function toggleTaskInSource(src: string, index: number): string {
  let n = 0;
  return src.replace(TASK_RE, (match, prefix: string, mark: string) =>
    n++ === index ? `${prefix}[${mark === " " ? "x" : " "}]` : match
  );
}

/**
 * Verdrahtet alle Checkboxen innerhalb von `root`. `onToggle` bekommt den
 * neuen Quelltext und speichert ihn; das Neurendern übernimmt der Aufrufer.
 *
 * Getroffen wird nicht nur das kleine Kästchen, sondern die ganze
 * Aufgabenzeile – Klick auf den Text hakt ab. Ausgenommen sind Links und
 * andere Bedienelemente sowie Klicks, die gerade Text markieren.
 */
export function bindTaskCheckboxes(
  root: HTMLElement,
  getSource: () => string,
  onToggle: (next: string) => void
): void {
  root.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const line = target.closest<HTMLElement>(".md-task-line");
    if (!line || !root.contains(line)) return;

    const box = line.querySelector<HTMLInputElement>("input.md-task");
    if (!box) return;

    if (target !== box) {
      // Eigene Bedienelemente behalten Vorrang.
      if (target.closest("a, button, input, textarea, select, summary, label")) return;
      // Wer Text markiert, will nichts abhaken.
      if ((window.getSelection()?.toString() ?? "").trim()) return;
      box.checked = !box.checked;
    }

    e.stopPropagation();
    const index = Number(box.dataset.task);
    if (Number.isNaN(index)) return;
    line.classList.toggle("is-done", box.checked);
    onToggle(toggleTaskInSource(getSource(), index));
  });
}
